/* ========================================
   BLOG TAG SWITCHER DATA UPDATE
   ======================================== */

function initBlogTagSwitcher() {
  const tagDataScript = document.querySelector('[data-blog-tag-data]');
  if (!tagDataScript) return;

  let tagData = {};
  try {
    tagData = JSON.parse(tagDataScript.textContent);
  } catch (e) {
    console.error('Failed to parse blog tag data:', e);
    return;
  }

  const currentUrl = window.location.href;
  const isTaggedPage = currentUrl.includes('/tagged/');

  // On tagged pages, fetch the main blog page to get unfiltered tag counts
  // On the main blog page, use the current page data
  if (isTaggedPage && tagData.blogUrl) {
    fetch(tagData.blogUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch blog data');
        }
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const fetchedTagDataScript = doc.querySelector('[data-blog-tag-data]');
        if (fetchedTagDataScript) {
          try {
            const fetchedTagData = JSON.parse(fetchedTagDataScript.textContent);
            updateTagSwitcherData(fetchedTagData);
          } catch (e) {
            console.error('Failed to parse fetched tag data:', e);
            updateTagSwitcherData(tagData);
          }
        } else {
          updateTagSwitcherData(tagData);
        }
      })
      .catch(error => {
        console.error('Error fetching blog data:', error);
        updateTagSwitcherData(tagData);
      });
  } else {
    updateTagSwitcherData(tagData);
  }

  function updateTagSwitcherData(data) {
    const tagItems = document.querySelectorAll('.bk-media-blog-tag-item');

    tagItems.forEach(item => {
      // Try to get tag name from data attribute first (more reliable)
      let tagName = item.getAttribute('data-tag-name');
      
      // Fallback to h3 text content
      if (!tagName) {
        const tagNameElement = item.querySelector('h3');
        if (tagNameElement) {
          tagName = tagNameElement.textContent.trim();
        }
      }

      if (!tagName) return;

      // Handle "Alle Themen" / "All Posts" / "Alle Artikel"
      if (tagName === 'Alle Artikel' || tagName === 'All Posts' || tagName === 'Alle Themen') {
        if (data.allArticlesCount !== undefined) {
          const countElement = item.querySelector('.text-subdued') || item.querySelector('p.text-subdued');
          if (countElement) {
            const count = data.allArticlesCount;
            const existingText = countElement.textContent;
            countElement.textContent = existingText.replace(/\d+/, count.toString());
          }
        }
        return;
      }

      // Handle individual tags - try exact match first
      let tagInfo = data.tags[tagName];
      
      // If not found, try case-insensitive match
      if (!tagInfo) {
        const availableTags = Object.keys(data.tags);
        const matchedTag = availableTags.find(t => t.toLowerCase() === tagName.toLowerCase());
        if (matchedTag) {
          tagInfo = data.tags[matchedTag];
        }
      }

      if (!tagInfo) {
        return;
      }

      const countElement = item.querySelector('.text-subdued') || item.querySelector('p.text-subdued[data-tag-count]') || item.querySelector('p.text-subdued');
      if (countElement && tagInfo.count !== undefined) {
        const count = tagInfo.count;
        const existingText = countElement.textContent;
        countElement.textContent = existingText.replace(/\d+/, count.toString());
      }

      // Update image if needed
      const imageWrapper = item.querySelector('.bk-media-blog-tag-item__image');
      if (imageWrapper && tagInfo.imageUrl) {
        const parentLi = item.closest('li');
        const hasBlockImage = parentLi && parentLi.id && parentLi.id.startsWith('block-');
        if (!hasBlockImage) {
          const existingImg = imageWrapper.querySelector('img:not(.placeholder-svg)');
          const placeholder = imageWrapper.querySelector('.placeholder-svg');

          if (placeholder) {
            const img = document.createElement('img');
            img.src = tagInfo.imageUrl;
            img.alt = tagName;
            img.loading = 'lazy';
            img.sizes = '(max-width: 699px) 50vw, 25vw';
            img.srcset = tagInfo.imageUrl.replace('_800x', '_200x') + ' 200w, ' +
                         tagInfo.imageUrl.replace('_800x', '_300x') + ' 300w, ' +
                         tagInfo.imageUrl.replace('_800x', '_400x') + ' 400w, ' +
                         tagInfo.imageUrl.replace('_800x', '_500x') + ' 500w, ' +
                         tagInfo.imageUrl.replace('_800x', '_600x') + ' 600w, ' +
                         tagInfo.imageUrl + ' 800w';
            img.width = 800;
            img.height = 600;
            placeholder.replaceWith(img);
          } else if (existingImg && (!existingImg.src || existingImg.src.includes('placeholder') || existingImg.src !== tagInfo.imageUrl)) {
            existingImg.src = tagInfo.imageUrl;
            existingImg.alt = tagName;
            existingImg.srcset = tagInfo.imageUrl.replace('_800x', '_200x') + ' 200w, ' +
                                tagInfo.imageUrl.replace('_800x', '_300x') + ' 300w, ' +
                                tagInfo.imageUrl.replace('_800x', '_400x') + ' 400w, ' +
                                tagInfo.imageUrl.replace('_800x', '_500x') + ' 500w, ' +
                                tagInfo.imageUrl.replace('_800x', '_600x') + ' 600w, ' +
                                tagInfo.imageUrl + ' 800w';
          } else if (!existingImg && !placeholder) {
            const img = document.createElement('img');
            img.src = tagInfo.imageUrl;
            img.alt = tagName;
            img.loading = 'lazy';
            img.sizes = '(max-width: 699px) 50vw, 25vw';
            img.srcset = tagInfo.imageUrl.replace('_800x', '_200x') + ' 200w, ' +
                         tagInfo.imageUrl.replace('_800x', '_300x') + ' 300w, ' +
                         tagInfo.imageUrl.replace('_800x', '_400x') + ' 400w, ' +
                         tagInfo.imageUrl.replace('_800x', '_500x') + ' 500w, ' +
                         tagInfo.imageUrl.replace('_800x', '_600x') + ' 600w, ' +
                         tagInfo.imageUrl + ' 800w';
            img.width = 800;
            img.height = 600;
            imageWrapper.appendChild(img);
          }
        }
      }
    });
  }
}

function scrollToActiveTag() {
  const tagList = document.querySelector('.tag-list.bk-media-blog-tag-list');
  if (!tagList || window.innerWidth > 699) return;
  
  const activeTag = tagList.querySelector('.bk-media-blog-tag-item.is-active');
  if (activeTag) {
    const tagItem = activeTag.closest('li');
    if (tagItem) {
      const scrollPosition = tagItem.offsetLeft - tagList.offsetLeft - (tagList.offsetWidth / 2) + (tagItem.offsetWidth / 2);
      tagList.scrollLeft = Math.max(0, scrollPosition);
    }
  } else {
    tagList.scrollLeft = 0;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initBlogTagSwitcher();
  setTimeout(scrollToActiveTag, 100);
});

document.addEventListener('shopify:section:load', function() {
  initBlogTagSwitcher();
  setTimeout(scrollToActiveTag, 100);
});

/* ========================================
   ANNOUNCEMENT BAR CUSTOM ELEMENTS
   ======================================== */

class MarqueeText extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(this._calculateDuration.bind(this)).observe(this);
    }
  }

  _calculateDuration(entries) {
    const scrollingSpeed = parseInt(this.getAttribute('scrolling-speed') || 5);
    const contentWidth = entries[0].contentRect.width;
    const item = entries[0].target.querySelector('.announcement-bar__item');
    if (!item) return;
    
    const itemWidth = item.clientWidth;
    const slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);
    const duration = scrollingSpeed * slowFactor * (itemWidth / contentWidth);
    this.style.setProperty('--marquee-animation-duration', `${duration.toFixed(3)}s`);
  }
}

if (!window.customElements.get('marquee-text')) {
  window.customElements.define('marquee-text', MarqueeText);
}

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.items = [];
    this.autoplayInterval = null;
    this.autoplayDelay = null;
    this.isTransitioning = false;
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('p'));
    if (this.items.length === 0) return;

    this.autoplayDelay = parseInt(this.getAttribute('autoplay')) || null;
    
    if (this.items.length > 1) {
      this._setupNavigation();
      if (this.autoplayDelay) {
        this._startAutoplay();
      }
      if (this.hasAttribute('swipeable')) {
        this._setupSwipe();
      }
    } else {
      this.items[0].classList.remove('reveal-invisible');
    }
  }

  disconnectedCallback() {
    this._stopAutoplay();
  }

  _setupNavigation() {
    const id = this.id;
    if (!id) return;

    const buttons = document.querySelectorAll(`[aria-controls="${id}"]`);
    buttons.forEach(button => {
      const label = button.getAttribute('aria-label') || '';
      if (label.toLowerCase().includes('previous') || label.toLowerCase().includes('prev')) {
        button.addEventListener('click', () => this._goToPrevious());
      } else if (label.toLowerCase().includes('next')) {
        button.addEventListener('click', () => this._goToNext());
      }
    });
  }

  _setupSwipe() {
    let startX = 0;
    let startY = 0;
    let isDragging = false;

    this.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = false;
    });

    this.addEventListener('touchmove', (e) => {
      if (!isDragging) {
        const deltaX = Math.abs(e.touches[0].clientX - startX);
        const deltaY = Math.abs(e.touches[0].clientY - startY);
        if (deltaX > deltaY && deltaX > 10) {
          isDragging = true;
        }
      }
    });

    this.addEventListener('touchend', (e) => {
      if (isDragging) {
        const endX = e.changedTouches[0].clientX;
        const deltaX = startX - endX;
        if (Math.abs(deltaX) > 50) {
          if (deltaX > 0) {
            this._goToNext();
          } else {
            this._goToPrevious();
          }
        }
      }
      isDragging = false;
    });
  }

  _transitionTo(fromIndex, toIndex) {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    const fromSlide = this.items[fromIndex];
    const toSlide = this.items[toIndex];

    if (fromSlide) {
      fromSlide.style.transform = 'translateY(-5px)';
      fromSlide.style.opacity = '0';
      fromSlide.style.visibility = 'hidden';
    }

    toSlide.classList.remove('reveal-invisible');
    toSlide.style.transform = 'translateY(0)';
    toSlide.style.opacity = '1';
    toSlide.style.visibility = 'visible';

    setTimeout(() => {
      if (fromSlide && fromIndex !== toIndex) {
        fromSlide.classList.add('reveal-invisible');
      }
      this.isTransitioning = false;
    }, 200);
  }

  _goToNext() {
    if (this.isTransitioning) return;
    const nextIndex = (this.currentIndex + 1) % this.items.length;
    this._transitionTo(this.currentIndex, nextIndex);
    this.currentIndex = nextIndex;
    this._restartAutoplay();
  }

  _goToPrevious() {
    if (this.isTransitioning) return;
    const prevIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
    this._transitionTo(this.currentIndex, prevIndex);
    this.currentIndex = prevIndex;
    this._restartAutoplay();
  }

  _startAutoplay() {
    if (!this.autoplayDelay) return;
    this._restartAutoplay();
  }

  _restartAutoplay() {
    this._stopAutoplay();
    if (this.autoplayDelay && this.items.length > 1) {
      this.autoplayInterval = setInterval(() => {
        this._goToNext();
      }, this.autoplayDelay * 1000);
    }
  }

  _stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
}

if (!window.customElements.get('announcement-bar')) {
  window.customElements.define('announcement-bar', AnnouncementBar);
}

class HeightObserver extends HTMLElement {
  constructor() {
    super();
    this.variable = this.getAttribute('variable');
  }

  connectedCallback() {
    if (!this.variable) return;
    
    const updateHeight = () => {
      const height = this.offsetHeight;
      document.documentElement.style.setProperty(`--${this.variable}-height`, `${height}px`);
    };

    if (window.ResizeObserver) {
      new ResizeObserver(updateHeight).observe(this);
    }
    
    updateHeight();
    setTimeout(updateHeight, 100);
  }
}

if (!window.customElements.get('height-observer')) {
  window.customElements.define('height-observer', HeightObserver);
}

class PrevButton extends HTMLElement {
  connectedCallback() {
    const controls = this.getAttribute('aria-controls');
    if (!controls) return;
    
    const target = document.getElementById(controls);
    if (!target) return;

    this.addEventListener('click', () => {
      if (target._goToPrevious) {
        target._goToPrevious();
      }
    });
  }
}

if (!window.customElements.get('prev-button')) {
  window.customElements.define('prev-button', PrevButton);
}

class NextButton extends HTMLElement {
  connectedCallback() {
    const controls = this.getAttribute('aria-controls');
    if (!controls) return;
    
    const target = document.getElementById(controls);
    if (!target) return;

    this.addEventListener('click', () => {
      if (target._goToNext) {
        target._goToNext();
      }
    });
  }
}

if (!window.customElements.get('next-button')) {
  window.customElements.define('next-button', NextButton);
}

/* ========================================
   PRODUCT PAGE DISCOUNT BADGE
   ======================================== */

let variantPricesDataGlobal = {};
let discountBadgeInitialized = false;

function updateDiscountBadge(variantId) {
  const discountBadge = document.querySelector('[data-discount-badge]');
  if (!discountBadge || !variantId) return;

  const variantIdStr = String(variantId);
  const variantIdNum = parseInt(variantId, 10);
  
  let compareAtPrice = 0;
  let price = 0;
  let variantData = null;

  if (variantPricesDataGlobal) {
    variantData = variantPricesDataGlobal[variantIdStr] || variantPricesDataGlobal[variantIdNum];
  }

  if (!variantData) {
    discountBadge.classList.add('hide');
    return;
  }

  compareAtPrice = variantData.compare_at_price || 0;
  price = variantData.price || 0;

  if (compareAtPrice && compareAtPrice > price) {
    const discountAmount = compareAtPrice - price;
    const formattedAmount = theme.Currency.formatMoney(discountAmount, theme.settings.moneyFormat).replace(',00', '');
    const saveText = discountBadge.getAttribute('data-save-text') || 'Spare {{ saved_amount }}';
    
    let badgeText = saveText;
    if (badgeText.includes('{{ saved_amount }}')) {
      badgeText = badgeText.replace('{{ saved_amount }}', formattedAmount);
    } else if (badgeText.includes('saved_amount')) {
      badgeText = badgeText.replace(/saved_amount/g, formattedAmount);
    } else {
      badgeText = 'Spare ' + formattedAmount;
    }
    
    discountBadge.textContent = badgeText;
    discountBadge.classList.remove('hide');
  } else {
    discountBadge.classList.add('hide');
  }
}

function getVariantIdFromForm() {
  const form = document.querySelector('form[id^="product-form"]');
  if (!form) return null;
  
  const selectElement = form.querySelector('select[name="id"]');
  if (selectElement && selectElement.value) {
    return selectElement.value;
  }
  
  const checkedInput = form.querySelector('input[name="id"]:checked');
  if (checkedInput && checkedInput.value) {
    return checkedInput.value;
  }
  
  const hiddenInput = form.querySelector('input[name="id"][type="hidden"]');
  if (hiddenInput && hiddenInput.value) {
    return hiddenInput.value;
  }
  
  return null;
}

function handleVariantChange() {
  setTimeout(function() {
    const variantId = getVariantIdFromForm();
    if (variantId) {
      updateDiscountBadge(variantId);
    }
  }, 100);
}

function initProductDiscountBadge() {
  const discountBadge = document.querySelector('[data-discount-badge]');
  if (!discountBadge) return;

  const variantPricesScript = document.querySelector('[data-variant-prices]');
  if (!variantPricesScript) return;

  try {
    variantPricesDataGlobal = JSON.parse(variantPricesScript.textContent);
  } catch (e) {
    console.error('Failed to parse variant prices data:', e);
    return;
  }

  if (!discountBadgeInitialized) {
    function handleVariantUpdate(event) {
      if (event.detail && event.detail.variant) {
        const variant = event.detail.variant;
        if (variant.id) {
          setTimeout(function() {
            updateDiscountBadge(variant.id);
          }, 50);
        } else {
          handleVariantChange();
        }
      } else {
        handleVariantChange();
      }
    }

    document.addEventListener('variant:change', handleVariantUpdate);
    
    const productContainer = document.querySelector('.product-single, [data-product-container]');
    if (productContainer) {
      productContainer.addEventListener('variantPriceChange', handleVariantUpdate);
    } else {
      document.addEventListener('variantPriceChange', handleVariantUpdate);
    }
    
    discountBadgeInitialized = true;
  }

  const form = document.querySelector('form[id^="product-form"]');
  if (form) {
    const selectElement = form.querySelector('select[name="id"]');
    if (selectElement) {
      selectElement.removeEventListener('change', handleVariantChange);
      selectElement.addEventListener('change', handleVariantChange);
    }
  }

  const initialVariantId = getVariantIdFromForm();
  if (initialVariantId) {
    updateDiscountBadge(initialVariantId);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initProductDiscountBadge();
  initBestpreisModal();
  relocateInfoBannerModalsToBody();
  initProductGalleryInfoBanners();
  initProductGalleryHotspots();
  initInfoBannerGalleryObservers();
  scheduleProductGalleryInfoBannerResize();
});

document.addEventListener('shopify:section:load', function() {
  setTimeout(initProductDiscountBadge, 100);
  setTimeout(initBestpreisModal, 100);
  setTimeout(function() {
    cleanupInfoBannerModalsFromBody();
    relocateInfoBannerModalsToBody();
    initProductGalleryInfoBanners();
    initProductGalleryHotspots();
  }, 100);
  setTimeout(initInfoBannerGalleryObservers, 50);
  setTimeout(scheduleProductGalleryInfoBannerResize, 150);
});

if (typeof window !== 'undefined') {
  window.addEventListener('load', scheduleProductGalleryInfoBannerResize);
}

document.addEventListener('lazyloaded', function(evt) {
  if (evt.target && evt.target.closest && evt.target.closest('.product-slideshow--info-banner')) {
    scheduleProductGalleryInfoBannerResize();
  }
});

document.addEventListener('product:rerender', function() {
  setTimeout(function() {
    initProductDiscountBadge();
    cleanupInfoBannerModalsFromBody();
    relocateInfoBannerModalsToBody();
    initProductGalleryInfoBanners();
    initProductGalleryHotspots();
    initInfoBannerGalleryObservers();
    scheduleProductGalleryInfoBannerResize();
  }, 100);
});

/* ========================================
   BESTPREIS GARANTIE MODAL
   ======================================== */

function initBestpreisModal() {
  const modal = document.querySelector('#BestpreisModal');
  if (!modal) return;

  if (!window.theme || !window.theme.Modals) {
    console.warn('Theme Modals not available');
    return;
  }

  new theme.Modals('BestpreisModal', 'bestpreis');
}

/* ========================================
   PRODUCT GALLERY INFO BANNER MODALS
   ======================================== */

function cleanupInfoBannerModalsFromBody() {
  document.querySelectorAll('body > .js-info-banner-modal').forEach(function(el) {
    el.remove();
  });
}

function relocateInfoBannerModalsToBody() {
  document.querySelectorAll('.js-info-banner-modal').forEach(function(modal) {
    if (modal.parentNode === document.body) {
      return;
    }
    document.body.appendChild(modal);
  });
}

function initProductGalleryInfoBanners() {
  if (!window.theme || !window.theme.Modals) {
    return;
  }

  document.querySelectorAll('.js-info-banner-modal').forEach(function(modal) {
    if (modal.dataset.infoBannerModalInit) {
      return;
    }
    var name = modal.getAttribute('data-modal-name');
    if (!modal.id || !name) {
      return;
    }
    modal.dataset.infoBannerModalInit = 'true';
    new theme.Modals(modal.id, name);
  });
}

function resizeProductGalleryInfoBanners() {
  document.querySelectorAll('.product-slideshow--info-banner.flickity-enabled').forEach(function(el) {
    var flkty = null;
    if (window.Flickity && typeof window.Flickity.data === 'function') {
      flkty = window.Flickity.data(el);
    }
    if (!flkty && el.flickity) {
      flkty = el.flickity;
    }
    if (flkty && typeof flkty.resize === 'function') {
      flkty.resize();
    }
  });
}

function scheduleProductGalleryInfoBannerResize() {
  resizeProductGalleryInfoBanners();
  setTimeout(resizeProductGalleryInfoBanners, 100);
  setTimeout(resizeProductGalleryInfoBanners, 500);
}

function bindInfoBannerFlickitySlideEvents(el) {
  if (!el || el.dataset.bkInfoBannerFlickityEvents) {
    return;
  }
  var flkty = null;
  if (window.Flickity && typeof window.Flickity.data === 'function') {
    flkty = window.Flickity.data(el);
  }
  if (!flkty && el.flickity) {
    flkty = el.flickity;
  }
  if (!flkty || typeof flkty.on !== 'function') {
    return;
  }
  el.dataset.bkInfoBannerFlickityEvents = '1';
  flkty.on('settle', function() {
    resizeProductGalleryInfoBanners();
    if (typeof closeAllGalleryHotspots === 'function') {
      closeAllGalleryHotspots();
    }
  });
}

function initInfoBannerGalleryObservers() {
  document.querySelectorAll('.product-slideshow--info-banner').forEach(function(slideshow) {
    if (slideshow.dataset.bkInfoBannerGalleryObs) {
      return;
    }
    slideshow.dataset.bkInfoBannerGalleryObs = '1';

    function attachWhenReady() {
      if (slideshow.classList.contains('flickity-enabled')) {
        bindInfoBannerFlickitySlideEvents(slideshow);
      }
    }

    attachWhenReady();

    if (typeof MutationObserver === 'undefined') {
      return;
    }
    var mo = new MutationObserver(function() {
      attachWhenReady();
    });
    mo.observe(slideshow, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  });
}

/* ========================================
   PRODUCT GALLERY HOTSPOTS
   ======================================== */

function bkMediaGetPswpHotspotImg(container) {
  if (!container) {
    return null;
  }
  var imgs = container.querySelectorAll('img.pswp__img');
  for (var j = 0; j < imgs.length; j++) {
    if (!imgs[j].classList.contains('pswp__img--placeholder')) {
      return imgs[j];
    }
  }
  return null;
}

function bkMediaMeasureImgInZoomWrap(container, img) {
  if (!img || !container) {
    return null;
  }
  var w = img.offsetWidth;
  var h = img.offsetHeight;
  if (!w || !h) {
    return null;
  }
  var l = 0;
  var t = 0;
  var el = img;
  while (el && el !== container) {
    l += el.offsetLeft;
    t += el.offsetTop;
    el = el.offsetParent;
  }
  if (el !== container) {
    var cr = container.getBoundingClientRect();
    var ir = img.getBoundingClientRect();
    var cw = container.clientWidth;
    var ch = container.clientHeight;
    if (cr.width > 0 && cr.height > 0 && cw > 0 && ch > 0) {
      var sx = cw / cr.width;
      var sy = ch / cr.height;
      l = (ir.left - cr.left) * sx;
      t = (ir.top - cr.top) * sy;
      w = ir.width * sx;
      h = ir.height * sy;
    }
  }
  return {
    l: Math.round(l * 100) / 100,
    t: Math.round(t * 100) / 100,
    w: Math.round(w * 100) / 100,
    h: Math.round(h * 100) / 100
  };
}

function bkMediaSigPhotoswipeLayout(m) {
  if (!m) {
    return '';
  }
  return [Math.round(m.l), Math.round(m.t), Math.round(m.w), Math.round(m.h)].join(',');
}

function bkMediaApplyPhotoswipeHotspotRect(container, m) {
  var root = container.querySelector('.pswp__hotspot-root');
  if (!root || !m) {
    return;
  }
  root.style.left = m.l + 'px';
  root.style.top = m.t + 'px';
  root.style.width = m.w + 'px';
  root.style.height = m.h + 'px';
  root.style.right = 'auto';
  root.style.bottom = 'auto';
}

function bkMediaAlignPhotoswipeHotspotRoot(container) {
  if (!container) {
    return false;
  }
  var root = container.querySelector('.pswp__hotspot-root');
  if (!root) {
    return false;
  }
  var img = bkMediaGetPswpHotspotImg(container);
  var m = bkMediaMeasureImgInZoomWrap(container, img);
  if (!m || !m.w || !m.h) {
    return false;
  }
  bkMediaApplyPhotoswipeHotspotRect(container, m);
  root.classList.add('pswp__hotspot-root--ready');
  return true;
}

function bkMediaAlignAllPhotoswipeHotspotRoots(gallery) {
  if (!gallery || !gallery.items) {
    return;
  }
  gallery.items.forEach(function(pswpItem) {
    if (pswpItem && pswpItem.container) {
      bkMediaAlignPhotoswipeHotspotRoot(pswpItem.container);
    }
  });
}

function bkMediaStopPhotoswipeHotspotLayoutWatch(container) {
  if (!container || !container._bkHotspotLayoutCleanup) {
    return;
  }
  container._bkHotspotLayoutCleanup();
  container._bkHotspotLayoutCleanup = null;
}

function bkMediaWatchPhotoswipeHotspotLayout(container) {
  if (!container) {
    return;
  }
  bkMediaStopPhotoswipeHotspotLayoutWatch(container);

  var root = container.querySelector('.pswp__hotspot-root');
  if (!root) {
    return;
  }
  root.classList.remove('pswp__hotspot-root--ready');

  var lastSig = '';
  var stableCount = 0;
  var start = Date.now();
  var rafId = 0;
  var frameCount = 0;
  var timeouts = [];
  var ro = null;
  var finished = false;

  function runCleanup() {
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = 0;
    }
    timeouts.forEach(function(id) {
      clearTimeout(id);
    });
    timeouts = [];
    if (ro) {
      ro.disconnect();
      ro = null;
    }
  }

  function finishWatch() {
    if (finished) {
      return;
    }
    finished = true;
    runCleanup();
    container._bkHotspotLayoutCleanup = null;
  }

  function finalize() {
    var img = bkMediaGetPswpHotspotImg(container);
    var m = bkMediaMeasureImgInZoomWrap(container, img);
    if (m && m.w && m.h) {
      bkMediaApplyPhotoswipeHotspotRect(container, m);
    } else {
      root.style.left = '0';
      root.style.top = '0';
      root.style.width = '100%';
      root.style.height = '100%';
      root.style.right = 'auto';
      root.style.bottom = 'auto';
    }
    root.classList.add('pswp__hotspot-root--ready');
  }

  function tick() {
    if (finished) {
      return true;
    }
    var img = bkMediaGetPswpHotspotImg(container);
    var m = bkMediaMeasureImgInZoomWrap(container, img);
    if (!m || !m.w || !m.h) {
      return false;
    }
    bkMediaApplyPhotoswipeHotspotRect(container, m);
    var sig = bkMediaSigPhotoswipeLayout(m);
    if (sig === lastSig) {
      stableCount += 1;
    } else {
      stableCount = 0;
      lastSig = sig;
    }
    if (stableCount >= 2) {
      root.classList.add('pswp__hotspot-root--ready');
      finishWatch();
      return true;
    }
    if (Date.now() - start > 950) {
      finalize();
      finishWatch();
      return true;
    }
    return false;
  }

  function rafLoop() {
    if (finished) {
      return;
    }
    frameCount += 1;
    if (tick()) {
      return;
    }
    if (frameCount > 100) {
      finalize();
      finishWatch();
      return;
    }
    rafId = requestAnimationFrame(rafLoop);
  }

  if (typeof ResizeObserver !== 'undefined') {
    ro = new ResizeObserver(function() {
      if (!finished && tick()) {
        return;
      }
    });
    ro.observe(container);
  }

  rafId = requestAnimationFrame(function() {
    rafLoop();
  });

  [0, 50, 120, 200, 340, 420, 520, 680, 850].forEach(function(ms) {
    timeouts.push(
      setTimeout(function() {
        if (!finished && tick()) {
          return;
        }
      }, ms)
    );
  });

  container._bkHotspotLayoutCleanup = function() {
    finishWatch();
  };
}

function bkMediaSyncPhotoswipeHotspotLayer(sectionId, item, galleryIndex) {
  if (!item || !item.container || !item.el) {
    return;
  }
  var scriptId = item.el.getAttribute('data-photoswipe-hotspots-id');
  var existing = item.container.querySelectorAll('.pswp__hotspot-root');
  if (!scriptId) {
    bkMediaStopPhotoswipeHotspotLayoutWatch(item.container);
    existing.forEach(function(n) {
      n.remove();
    });
    return;
  }
  var scriptEl = document.getElementById(scriptId);
  if (!scriptEl) {
    return;
  }
  var list;
  try {
    list = JSON.parse(scriptEl.textContent.trim());
  } catch (err) {
    return;
  }
  if (!list || !list.length) {
    bkMediaStopPhotoswipeHotspotLayoutWatch(item.container);
    existing.forEach(function(n) {
      n.remove();
    });
    return;
  }
  var existingRoot = item.container.querySelector('.pswp__hotspot-root');
  if (
    existingRoot &&
    existingRoot.getAttribute('data-bk-pswp-script') === scriptId &&
    bkMediaGetPswpHotspotImg(item.container)
  ) {
    bkMediaWatchPhotoswipeHotspotLayout(item.container);
    return;
  }
  bkMediaStopPhotoswipeHotspotLayoutWatch(item.container);
  existing.forEach(function(n) {
    n.remove();
  });
  var root = document.createElement('div');
  root.className = 'pswp__hotspot-root';
  root.setAttribute('data-bk-pswp-script', scriptId);
  var sid = sectionId || 'p';
  list.forEach(function(h, hi) {
    var panelId = 'GalleryHotspotPanel-pswp-' + sid + '-' + galleryIndex + '-' + hi;
    var triggerId = 'GalleryHotspotTrigger-pswp-' + sid + '-' + galleryIndex + '-' + hi;
    var layer = document.createElement('div');
    layer.className = 'product-gallery__hotspot-layer';
    layer.setAttribute('data-product-gallery-hotspot-root', '');
    layer.style.zIndex = String(h.z != null ? h.z : 40 + hi);
    layer.style.setProperty('--hotspot-x', h.x + '%');
    layer.style.setProperty('--hotspot-y', h.y + '%');
    layer.style.setProperty('--hotspot-dot', h.dot || '#124B3A');
    layer.style.setProperty('--hotspot-dot-outline', h.dotOutline || '#ffffff');
    layer.style.setProperty('--hotspot-ring', h.ring || '#353531');
    layer.style.setProperty('--hotspot-panel-bg', h.panelBg || 'rgba(53,53,49,0.45)');
    layer.style.setProperty('--hotspot-panel-text', h.panelText || '#FCF8F1');
    var hotspot = document.createElement('div');
    hotspot.className = 'product-gallery__hotspot';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = triggerId;
    btn.className = 'product-gallery__hotspot-dot js-gallery-hotspot-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', panelId);
    var pulse = document.createElement('span');
    pulse.className = 'product-gallery__hotspot-pulse';
    pulse.setAttribute('aria-hidden', 'true');
    var core = document.createElement('span');
    core.className = 'product-gallery__hotspot-core';
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = h.title || 'Info';
    btn.appendChild(pulse);
    btn.appendChild(core);
    btn.appendChild(sr);
    var panel = document.createElement('div');
    panel.id = panelId;
    panel.className = 'product-gallery__hotspot-panel prose';
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-labelledby', triggerId);
    panel.setAttribute('hidden', '');
    if (h.title) {
      var tp = document.createElement('p');
      tp.className = 'product-gallery__hotspot-title';
      tp.textContent = h.title;
      panel.appendChild(tp);
    }
    if (h.content) {
      var body = document.createElement('div');
      body.className = 'product-gallery__hotspot-body rte';
      body.innerHTML = h.content;
      panel.appendChild(body);
    }
    hotspot.appendChild(btn);
    hotspot.appendChild(panel);
    layer.appendChild(hotspot);
    root.appendChild(layer);
  });
  item.container.appendChild(root);
  bkMediaWatchPhotoswipeHotspotLayout(item.container);
}

window.bkMediaInitPhotoswipeHotspots = function(ui) {
  var gallery = ui.gallery;
  if (!gallery) {
    return;
  }
  var sectionId = ui.sectionId || 'p';
  ui._photoswipeVvResize = null;

  var alignAll = function() {
    bkMediaAlignAllPhotoswipeHotspotRoots(gallery);
  };

  gallery.listen('afterChange', function() {
    ui.afterChange();
    var idx = gallery.getCurrentIndex();
    var item = gallery.items[idx];
    if (item) {
      bkMediaSyncPhotoswipeHotspotLayer(sectionId, item, idx);
    }
  });

  gallery.listen('imageLoadComplete', function(index, item) {
    bkMediaSyncPhotoswipeHotspotLayer(sectionId, item, index);
  });

  gallery.listen('resize', alignAll);
  gallery.listen('zoomGestureEnded', alignAll);
  gallery.listen('mainScrollAnimComplete', alignAll);
  gallery.listen('doubleTap', function() {
    setTimeout(alignAll, 350);
  });

  if (window.visualViewport) {
    ui._photoswipeVvResize = alignAll;
    window.visualViewport.addEventListener('resize', ui._photoswipeVvResize, { passive: true });
  }

  gallery.listen('destroy', function() {
    if (gallery.items) {
      gallery.items.forEach(function(pswpItem) {
        if (pswpItem && pswpItem.container) {
          bkMediaStopPhotoswipeHotspotLayoutWatch(pswpItem.container);
        }
      });
    }
    if (ui._photoswipeVvResize && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', ui._photoswipeVvResize);
      ui._photoswipeVvResize = null;
    }
  });
};

function resetHotspotPanelLayout(panel) {
  if (!panel) {
    return;
  }
  panel.style.removeProperty('--hotspot-panel-nudge-x');
  panel.style.removeProperty('--hotspot-panel-nudge-y');
  panel.style.removeProperty('--hotspot-panel-max-w');
  panel.style.removeProperty('max-height');
  panel.classList.remove('product-gallery__hotspot-panel--flip');
  panel.classList.remove('product-gallery__hotspot-panel--place-right');
  panel.classList.remove('product-gallery__hotspot-panel--place-left');
}

function constrainHotspotPanel(panel, layer) {
  if (!panel || !layer) {
    return;
  }
  var pad = 8;
  var lr = layer.getBoundingClientRect();
  var hotspotEl = layer.querySelector('.product-gallery__hotspot');
  if (!hotspotEl) {
    return;
  }
  var hr = hotspotEl.getBoundingClientRect();
  var gap = 10;
  var availBelow = lr.bottom - hr.bottom - pad - gap;
  var availAbove = hr.top - lr.top - pad - gap;
  var availRight = lr.right - hr.right - pad - gap;
  var availLeft = hr.left - lr.left - pad - gap;

  panel.style.removeProperty('--hotspot-panel-nudge-x');
  panel.style.removeProperty('--hotspot-panel-nudge-y');
  panel.style.removeProperty('max-height');
  panel.classList.remove('product-gallery__hotspot-panel--flip');
  panel.classList.remove('product-gallery__hotspot-panel--place-right');
  panel.classList.remove('product-gallery__hotspot-panel--place-left');

  var best = 'below';
  var bestSpace = availBelow;
  if (availAbove > bestSpace) {
    bestSpace = availAbove;
    best = 'above';
  }
  if (availRight > bestSpace) {
    bestSpace = availRight;
    best = 'right';
  }
  if (availLeft > bestSpace) {
    bestSpace = availLeft;
    best = 'left';
  }

  var maxW;
  if (best === 'right') {
    maxW = Math.min(420, Math.max(120, availRight));
  } else if (best === 'left') {
    maxW = Math.min(420, Math.max(120, availLeft));
  } else {
    maxW = Math.max(120, Math.min(420, lr.width - pad * 2));
  }
  panel.style.setProperty('--hotspot-panel-max-w', maxW + 'px');

  if (best === 'above') {
    panel.classList.add('product-gallery__hotspot-panel--flip');
  } else if (best === 'right') {
    panel.classList.add('product-gallery__hotspot-panel--place-right');
  } else if (best === 'left') {
    panel.classList.add('product-gallery__hotspot-panel--place-left');
  }

  function apply() {
    var pr = panel.getBoundingClientRect();
    var maxH;

    if (best === 'below' || best === 'above') {
      var dx = 0;
      if (pr.right > lr.right - pad) {
        dx += lr.right - pad - pr.right;
      }
      if (pr.left + dx < lr.left + pad) {
        dx = lr.left + pad - pr.left;
      }
      panel.style.setProperty('--hotspot-panel-nudge-x', dx + 'px');
      panel.style.removeProperty('--hotspot-panel-nudge-y');

      pr = panel.getBoundingClientRect();
      if (best === 'above') {
        maxH = pr.bottom - lr.top - pad;
      } else {
        maxH = lr.bottom - pr.top - pad;
      }
      maxH = Math.min(520, Math.max(96, maxH));
      panel.style.maxHeight = maxH + 'px';
    } else {
      var dy = 0;
      if (pr.bottom > lr.bottom - pad) {
        dy += lr.bottom - pad - pr.bottom;
      }
      if (pr.top + dy < lr.top + pad) {
        dy = lr.top + pad - pr.top;
      }
      panel.style.setProperty('--hotspot-panel-nudge-y', dy + 'px');
      panel.style.removeProperty('--hotspot-panel-nudge-x');

      pr = panel.getBoundingClientRect();
      maxH = lr.bottom - pr.top - pad;
      maxH = Math.min(520, Math.max(96, maxH));
      panel.style.maxHeight = maxH + 'px';
    }
  }

  requestAnimationFrame(function() {
    requestAnimationFrame(apply);
  });
}

function closeGalleryHotspot(root) {
  if (!root) {
    return;
  }
  var toggle = root.querySelector('.js-gallery-hotspot-toggle');
  var panel = toggle ? document.getElementById(toggle.getAttribute('aria-controls')) : null;
  root.classList.remove('is-hotspot-expanded');
  if (toggle) {
    toggle.setAttribute('aria-expanded', 'false');
  }
  if (panel) {
    panel.setAttribute('hidden', '');
    resetHotspotPanelLayout(panel);
  }
}

function closeAllGalleryHotspots() {
  document.querySelectorAll('[data-product-gallery-hotspot-root].is-hotspot-expanded').forEach(function(root) {
    closeGalleryHotspot(root);
  });
}

function openGalleryHotspot(root) {
  var toggle = root.querySelector('.js-gallery-hotspot-toggle');
  var panel = toggle ? document.getElementById(toggle.getAttribute('aria-controls')) : null;
  if (!toggle || !panel) {
    return;
  }
  root.classList.add('is-hotspot-expanded');
  toggle.setAttribute('aria-expanded', 'true');
  panel.removeAttribute('hidden');
  resetHotspotPanelLayout(panel);
  constrainHotspotPanel(panel, root);
}

function initProductGalleryHotspots() {
  if (window.__bkGalleryHotspotInit) {
    return;
  }
  window.__bkGalleryHotspotInit = true;

  document.addEventListener('click', function(e) {
    var toggleBtn = e.target.closest && e.target.closest('.js-gallery-hotspot-toggle');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      var root = toggleBtn.closest('[data-product-gallery-hotspot-root]');
      if (!root) {
        return;
      }
      var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('[data-product-gallery-hotspot-root].is-hotspot-expanded').forEach(function(r) {
        if (r !== root) {
          closeGalleryHotspot(r);
        }
      });
      if (expanded) {
        closeGalleryHotspot(root);
      } else {
        openGalleryHotspot(root);
      }
      return;
    }

    if (e.target.closest && e.target.closest('.product-gallery__hotspot')) {
      return;
    }

    closeAllGalleryHotspots();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllGalleryHotspots();
    }
  });

  var resizeTicking = false;
  window.addEventListener(
    'resize',
    function() {
      if (resizeTicking) {
        return;
      }
      resizeTicking = true;
      requestAnimationFrame(function() {
        resizeTicking = false;
        document.querySelectorAll('[data-product-gallery-hotspot-root].is-hotspot-expanded').forEach(function(root) {
          var panel = root.querySelector('.product-gallery__hotspot-panel');
          if (!panel || panel.hasAttribute('hidden')) {
            return;
          }
          constrainHotspotPanel(panel, root);
        });
      });
    },
    { passive: true }
  );
}

/* ========================================
   X-TABS WEB COMPONENT
   ======================================== */

(function() {
  function animate(element, keyframes, options) {
    return element.animate(keyframes, options);
  }

  class Tabs extends HTMLElement {
    static get observedAttributes() {
      return ["selected-index"];
    }

    constructor() {
      super();
      if (!this.shadowRoot) {
        this.attachShadow({ mode: "open" }).appendChild(
          this.querySelector("template").content.cloneNode(true)
        );
      }
      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => {
          this.selectedIndex = this.buttons.indexOf(event.target);
        });
      }
      this.addEventListener("keydown", this._handleKeyboard.bind(this));
    }

    connectedCallback() {
      this._abortController = new AbortController();
      const titleSlot = this.shadowRoot.querySelector('slot[name="title"]');
      const contentSlot = this.shadowRoot.querySelector('slot[name="content"]');
      
      if (titleSlot && contentSlot) {
        this.buttons = Array.from(
          titleSlot.assignedNodes(),
          (item) => (item.matches("button") && item) || item.querySelector("button")
        );
        this.panels = Array.from(contentSlot.assignedNodes());
        this.buttons.forEach((button, index) => {
          button.addEventListener(
            "click",
            () => (this.selectedIndex = index),
            { signal: this._abortController.signal }
          );
        });
        this.selectedIndex = this.selectedIndex;
        this._setupAccessibility();
      }
    }

    disconnectedCallback() {
      if (this._abortController) {
        this._abortController.abort();
      }
    }

    get animationDuration() {
      return this.hasAttribute("animation-duration")
        ? parseFloat(this.getAttribute("animation-duration"))
        : 0.15;
    }

    get selectedIndex() {
      return parseInt(this.getAttribute("selected-index")) || 0;
    }

    set selectedIndex(index) {
      this.setAttribute(
        "selected-index",
        Math.min(Math.max(index, 0), this.buttons.length - 1).toString()
      );
      this.style.setProperty("--selected-index", this.selectedIndex.toString());
      this.style.setProperty("--item-count", this.buttons.length.toString());
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (!this.buttons || !this.panels) return;
      
      this.buttons.forEach((button, index) =>
        button.setAttribute(
          "aria-selected",
          index === parseInt(newValue) ? "true" : "false"
        )
      );
      if (
        name === "selected-index" &&
        oldValue !== null &&
        oldValue !== newValue
      ) {
        this._transition(
          this.panels[parseInt(oldValue)],
          this.panels[parseInt(newValue)]
        );
      }
    }

    _setupAccessibility() {
      const componentID = crypto.randomUUID
        ? crypto.randomUUID()
        : Math.floor(Math.random() * 1e4);
      this.buttons.forEach((button, index) => {
        button.setAttribute("role", "tab");
        button.setAttribute(
          "aria-controls",
          `tab-panel-${componentID}-${index}`
        );
        button.id = `tab-${componentID}-${index}`;
      });
      this.panels.forEach((panel, index) => {
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute(
          "aria-labelledby",
          `tab-${componentID}-${index}`
        );
        panel.id = `tab-panel-${componentID}-${index}`;
        panel.hidden = index !== this.selectedIndex;
      });
    }

    _handleKeyboard(event) {
      const index = this.buttons.indexOf(document.activeElement);
      if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
        return;
      }
      if (event.key === "ArrowLeft") {
        this.selectedIndex =
          (this.selectedIndex - 1 + this.buttons.length) % this.buttons.length;
      } else {
        this.selectedIndex =
          (this.selectedIndex + 1 + this.buttons.length) % this.buttons.length;
      }
      this.buttons[this.selectedIndex].focus();
    }

    async _transition(fromPanel, toPanel) {
      if (!fromPanel || !toPanel) return;
      
      try {
        await animate(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
        fromPanel.hidden = true;
        toPanel.hidden = false;
        await animate(toPanel, { opacity: [0, 1] }, { duration: this.animationDuration }).finished;
      } catch (e) {
        fromPanel.hidden = true;
        toPanel.hidden = false;
      }
    }
  }

  if (!window.customElements.get("x-tabs")) {
    window.customElements.define("x-tabs", Tabs);
  }
})();

